"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var getDisplayRowIndex = require("./getDisplayRowIndex");
var getImportDataRows = require("./getImportDataRows");

function getRowsToGeocode(vm, $translate) {
  return getRowsGeocodeHelper(true, vm, $translate);
}

function getRowsNotToGeocode(vm, $translate) {
  return getRowsGeocodeHelper(false, vm, $translate);
}

function getRowsGeocodeHelper(toGeocode, vm, $translate) {
  var importRowsToSubmit = getImportDataRows(vm);
  var rows = importRowsToSubmit.map(function (row, i) {
    if (shouldGeocodeRow(row, vm) === toGeocode) {
      return getRowObjFromArray(row, i, vm);
    }
  }).filter(function (a) {
    return a;
  });
  if (vm.isPlacesImport) {
    return nameUnnamedRows(rows, $translate);
  } else {
    return rows;
  }
}

//Given a row in array format (i.e. ["1", "2", "08540"]) get an object version of it (i.e. { Latitude: "1", Longitude: "2", "Zip": "08540"})
//The keys are the field names (internal ones, in the importField.js object's name property). The values are the row's CSV input contents
function getRowObjFromArray(row, i, vm) {
  var retObj = {};
  for (var j = 0; j < row.length; j++) {
    if (vm.headers[j] === "Skip") {
      continue;
    }
    if (vm.headers[j] === "LatLon") {
      var _row$j$split = row[j].split(","),
          _row$j$split2 = _slicedToArray(_row$j$split, 2),
          lat = _row$j$split2[0],
          lon = _row$j$split2[1];

      retObj.Latitude = lat;
      retObj.Longitude = lon;
    } else {
      retObj[vm.headers[j]] = row[j];
    }
  }
  retObj.RowNum = getDisplayRowIndex(i, vm);
  return retObj;
}

//Given row and field name get row/col string entry that has that field
// returns non-empty string (good), "" (omitted), or undefined (missing from cols)
function getRowVal(row, fieldKey, vm) {
  var index = vm.headers.indexOf(fieldKey);
  return row[index];
}

function nameUnnamedRows(rows, $translate) {
  var unnamedCounter = 1;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var row = _step.value;

      if (!row.PlaceName) {
        row.PlaceName = $translate.instant("templates.importPlaces.defaultImportedPlaceName", {
          num: unnamedCounter
        });
        unnamedCounter++;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return rows;
}

//Should we geocode vm row? (Row must have valid address combo)
function shouldGeocodeRow(row, vm) {
  var hasCity = Boolean(getRowVal(row, "City", vm));
  var hasState = Boolean(getRowVal(row, "State", vm));
  var hasZip = Boolean(getRowVal(row, "Zip", vm));
  var hasLat = Boolean(getRowVal(row, "Latitude", vm));
  var hasLon = Boolean(getRowVal(row, "Longitude", vm));
  var hasLatLon = Boolean(getRowVal(row, "LatLon", vm));

  return hasLat && hasLon || hasLatLon || hasZip || hasCity && hasState;
}

module.exports = { getRowsToGeocode: getRowsToGeocode, getRowsNotToGeocode: getRowsNotToGeocode };


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-import/vm-helpers/getRowsGeocodeHelper.js